import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Reservations.css';

// Query
import reservationsQuery from './reservationsQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

// Component
import ReservationManagement from '../../../components/siteadmin/ReservationManagement';

class Reservations extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getAllReservationAdmin: PropTypes.array,
    })
  };

  static defaultProps = {
    getAllReservations: {
      loading: true,
      getAllReservationAdmin: {
        count: null,
        reservationData: []
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      searchType: ''
    };
  }

  changeState = (variables) => this.setState(variables)

  render() {
    const { getAllReservations } = this.props;

    return <ReservationManagement
      changeStateValues={this.changeState}
      currentPage={this.state.currentPage}
      searchList={this.state.searchList}
      searchType={this.state.searchType}
      getAllReservations={getAllReservations}
    />
  }

}

export default compose(
  withStyles(s),
  withQuery(reservationsQuery, {
    name: 'getAllReservations',
    options: {
      variables: {
        currentPage: 1,
        searchList: '',
        searchType: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(Reservations);
